// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    COMPANY_AWARDS_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_AWARDS_LOADED() {
      return {
        isLoading: false,
        data: action.companyAwards
      };
    },
    COMPANY_AWARDS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyAwards.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
